import Switchery from 'switchery-npm';

function setup() {
    $('.tap-switch-primary').each(function(){
        new Switchery(this, { color: '#76b2bf', secondaryColor: "#ebebeb" });
    });

    $('.tap-switch-success').each(function(){
        new Switchery(this, { color: '#37d1b3', secondaryColor: "#ebebeb" });
    });

    $('.tap-switch-danger').each(function(){
        new Switchery(this, { color: '#f05a3c', secondaryColor: "#ebebeb" });
    });
}

module.exports.setup = setup;
